import Navbar from "../components/Navbar"
import footerPic from '../images/footer man.png'
import logo from '../images/logo.png'

const Contact = () => {
    let div = ' < div >';
    let dc =  '< div/>';

    return(
          <div>
            <Navbar/>
             <footer id="footer">
          <div class="container">
            <div class="row">
                
                <div class="col-lg-7 footerContent">
                    <h4>lets make something amazing today.</h4>
                    

                    
                    <div class="footerInfo">
                        <span>{div}</span>
                        <h3>information</h3>
                        <div class="footerText"> <a href="mailto:craigtogs@gmail.com"><h4>email:craigtogs@email.com</h4></a> </div>
                       <div class="footerText">
                        <h5>phone no:</h5> 
                        <table>
                            <tr>
                              <h4><td class="phonecall">+263788922474</td></h4>
                            </tr>
                          </table>
                    
                    </div>
                        

                        <div class="col-sm-12">
                            <div class="footerIcons">
                                <a href="https://github.com/tristenswisss"><i class="fa-brands fa-github"></i></a>
                                <a href="https://www.linkedin.com/in/craig-togarepi-97b0b1139/"><i class="fa-brands fa-linkedin"></i> </a> 
                                 <a href="https://www.instagram.com/swisss_2.0/"><i class="fa-brands fa-instagram"></i> </a>
                            </div>
                            
                        </div>

                         <span>{dc}</span>


                    </div>
                       
                </div>

                <div class="col-lg-5">

                    <img src={footerPic} class="img-fluid" alt='footerPic'/>

                    
                </div>



            </div>



          </div>

          <div class="footerLine"></div>

          <div class="copyright">
            <div class="container">
                <img src={logo} alt="logo" class="img-fluid"/>
                

            </div>
            <div className='copyrightText'>
            <p>copyright 2023.  All rights reserved</p>

            </div>
           
            

          </div>



   </footer>

          </div>
       

    );
};

export default Contact;
